import AdvertiserApi from '@/api/AdvertiserApi'
import { AdvertiserModel } from '@/models/Advertiser'
import { AgencyModel } from '@/models/Agency'

const assignModel = data => {
  return data.map(o => new AdvertiserModel(o))
}

const actions = {
  async SEARCH(
    { commit },
    {
      keyword,
      minPermissionLevel,
      advertiserStatuses,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    },
  ) {
    commit('SET_LOADING', 'search')
    const searchResult = await AdvertiserModel.search({
      keyword,
      minPermissionLevel,
      advertiserStatuses,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    })
    searchResult['pageSize'] = pageSize
    commit('SET_SEARCH_RESULT', searchResult)
    commit('CLEAR_LOADING', 'search')
  },
  async GET_ADVERTISER_LIST({ commit }, { minPermissionLevel }) {
    const listData = await AdvertiserApi.fetchAdvertiserList(minPermissionLevel)
    const { items } = listData
    const modeledItems = assignModel(items)
    commit('SET_ADVERTISER_LIST', modeledItems)
  },
  async SEARCH_AGENCY({ commit }, { keyword, minPermissionLevel }) {
    const params = { keyword, minPermissionLevel }
    const ret = await AgencyModel.searchAgency(params)
    const { items } = ret
    commit('SET_AGENCY_LIST', items)
  },
  async CLEAR_AGENCY_LIST({ commit }) {
    commit('CLEAR_AGENCY_LIST')
  },
  /* eslint-disable no-unused-vars */
  async ADD_ADVERTISER({ commit, dispatch, state }, item) {
    await AdvertiserApi.addAdvertiser(item)
  },
  async GET_AGENCY_ACCOUNT_LIST({ commit }, { agencyId, minPermissionLevel }) {
    const params = { minPermissionLevel }
    // ここはagencyに対して権限をもつアカウントを取得するので、責務はadvertiserモデルではなくagencyモデル
    const ret = await AgencyModel.getAgencyAccountList(agencyId, params)
    const { items } = ret
    commit('SET_AGENCY_ACCOUNT_LIST', items)
  },
  async CLEAR_AGENCY_ACCOUNT_LIST({ commit }) {
    commit('CLEAR_AGENCY_ACCOUNT_LIST')
  },
  SET_SEARCH_KEYWORD({ commit }, keyword) {
    commit('SET_KEYWORD', keyword)
  },
  SET_SEARCH_PAGE_NO({ commit }, pageNo) {
    commit('SET_PAGE_NO', pageNo)
  },
  SET_SESRCH_PAGE_SIZE({ commit }, pageSize) {
    commit('SET_PAGE_SIZE', pageSize)
  },
  SET_SORT_OPRIONS({ commit }, sortOptions) {
    commit('SET_SORT_OPRIONS', sortOptions)
  },
  /* eslint-disable-line no-unused-vars */
}

export default actions
